import {NgModule} from '@angular/core';
import {DynamicComponentFactoryService} from './dynamic-component-factory.service';

@NgModule({
    providers: [
        DynamicComponentFactoryService
    ]
})
export class DynamicComponentFactoryModule {}
